var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFoodStoneFruit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33.9 35.4",
    style: {
      enableBackground: "new 0 0 33.9 35.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#AA0012;stroke:#1A1818;stroke-width:1.592;stroke-miterlimit:10;}\n\t.st1{fill:#C95C45;}\n\t.st2{fill:#7C0007;}\n\t.st3{fill:#78A958;stroke:#1A1818;stroke-width:1.592;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    transform: "translate(-1553.607 -1880.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    className: "st0",
    d: "M1556.6,1907c-0.2,3.3,2,6.5,6.1,7.6s7.6-0.6,9.1-3.6c1.8-3.4,0.6-6.2-1.7-7.5 c-2-1.1-2.7-0.4-4.2-0.8s-1.8-1.4-4.1-1.4C1559.3,1901.3,1556.8,1903.1,1556.6,1907"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    className: "st1",
    d: "M1562.8,1914L1562.8,1914z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    className: "st2",
    d: "M1567.5,1903.3c-0.4,0.6-1.2,0.8-1.9,0.6c-0.9-0.2-1.4-1.2-1.3-1.5c0.1-0.3,0.7,0.2,1.6,0.5 C1566.8,1903.2,1567.6,1903,1567.5,1903.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    transform: "translate(1570.645 1901.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    className: "st0",
    d: "M10.8,0C8.5,0,8.3,1,6.7,1.4S4.5,1,2.5,2.2C0.3,3.5-0.9,6.3,0.8,9.7c1.5,2.9,5.1,4.6,9.1,3.6 S16.2,9,16,5.7C15.8,1.8,13.4,0,10.8,0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    transform: "translate(9.825 12.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_172"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    className: "st1",
    d: "M0,0L0,0z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    className: "st2",
    d: "M8.4,1.2C8.5,1.5,8,2.5,7.1,2.7C6.4,2.9,5.7,2.6,5.2,2C5.2,1.7,6,1.9,6.8,1.7S8.3,0.9,8.4,1.2z "
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    className: "st3",
    d: "M1578.2,1903c-0.2-1.5-0.6-2.9-1.2-4.3c-0.3-0.9-0.7-1.8-1.1-2.7c-0.6-1.6-1.3-3.2-1.9-5 c-0.2-0.8-0.4-1.5-0.6-2.3c-0.6-2.3-0.4-4.8,0.6-7h-2.3c-1.1,2.8-1.3,6.3-2.3,9.3c-0.6,1.8-1.2,3.4-1.9,5c-1,2.2-1.8,4.6-2.2,7 c0,0.3,0.2,0.6,0.5,0.7c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.3,0,0.6-0.2,0.7-0.6c0.4-2.3,1.2-4.6,2.2-6.7c1.3-2.9,2.3-6,2.9-9.1 c0.6,3.1,1.6,6.2,2.9,9.1c1,2.1,1.7,4.4,2.2,6.7c0,0.3,0.2,0.5,0.5,0.5l0,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0 c0.3-0.1,0.4-0.3,0.5-0.5C1578.2,1903.1,1578.2,1903.1,1578.2,1903z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    className: "st3",
    d: "M1571.7,1881.7c-4.7-1.5-9.8,0.1-12.9,4c-5.6,6.7-4.2,6.6-4.2,6.6S1567.7,1893.8,1571.7,1881.7z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFoodStoneFruit);
export default __webpack_public_path__ + "static/media/icon-food-stone-fruit.96b69963e38acb40cb5672075e7cec6f.svg";
export { ForwardRef as ReactComponent };